import { triggerAction } from "../constants"
import { AuthAPI, backendAPI, deleteCookie, setAuthorizationToken } from "../api"
import { getGeolocation } from "../../view/shared/helpers"
import { v4 as uuid } from "uuid"
import { safeApiCall } from "../api/offline"
import { precacheData } from "./precache"
import Cookies from "js-cookie"

export const getUser = () => async (dispatch, getState) => {
  try {
    const { user } = getState()
    const headers = {
      headers: {
        Authorization: "Bearer " + user.token || localStorage.getItem("token"),
      },
    }
    const { data } = await safeApiCall(
      {
        cacheEnabled: true,
        url: `/users/me`,
      },
      async () => backendAPI.get(`/users/me`, headers),
    )
    const userDetails = await safeApiCall(
      {
        cacheEnabled: true,
        url: `/users/${data.id}`,
      },
      async () => AuthAPI.get(`/users/${data.id}`, headers),
    )
    const obj = {
      ...user,
      ...data,
      hashed_resetcode: null,
      ...userDetails.data,
    }
    dispatch(triggerAction("SET_USER_DATA", obj))
    return Promise.resolve(obj)
  } catch (error) {
    console.log("Error: ", error)
    return Promise.reject()
  }
}

export const logoutAction = () => async (dispatch, getState) => {
  const { user } = getState()
  const lang = localStorage.getItem("lang") || "en"
  const session_id = sessionStorage.getItem("ta_id")
  const _country = localStorage.getItem("_country")
  if (!user) {
    return
  }
  trackActivity({
    session_id,
    logged_in: false,
    person_name: user.full_name,
    user_id: user.id,
    logout_time: new Date().toISOString(),
  })
  // disconnect user from web socket server
  dispatch({
    type: "WEBSOCKET_ACTION",
    pushEvent: "disconnect",
    receiveEvent: "response",
    emit: true,
    payload: {},
  })
  localStorage.removeItem("uConnected")
  sessionStorage.removeItem("ta_id")
  localStorage.clear()
  localStorage.setItem("lang", lang)
  localStorage.setItem("_country", _country)
  dispatch(triggerAction("RESET"))
  dispatch(triggerAction("SET_USER_DATA", null))
  setAuthorizationToken(null, null)
  Cookies.remove("token", { path: "/" }) // removed cookie
  Cookies.remove("tokenBC", { path: "/" }) // removed cookie
}

export const loginAction = (phone_number, password) => async (dispatch) => {
  const modifiedEmail = "+" + phone_number

  try {
    const getOwnerCredentials = async () =>
      await AuthAPI.post("/login?app=vsla", {
        grant_type: "password",
        username: modifiedEmail,
        password: password,
      })

    const { data } = await safeApiCall(
      {
        cacheEnabled: true,
        isLoginRequest: true,
        username: modifiedEmail,
        password: password,
      },
      getOwnerCredentials,
    )
    const user = data.user
    if (!user) {
      return
    }
    dispatch(
      triggerAction("SET_USER_DATA", {
        ...data.user,
        token: data.access_token,
        tokenBC: data.bc_access_token,
      }),
    )
    setAuthorizationToken(data.access_token, data.bc_access_token)
    const updatedUser = {
      ...data.user,
      hashed_resetcode: null,
      token: data.access_token,
      tokenBC: data.bc_access_token,
    }
    dispatch(triggerAction("SET_USER_DATA", updatedUser))
    dispatch(precacheData())
    localStorage.setItem("email", phone_number)
    const session_id = uuid()
    sessionStorage.setItem("ta_id", session_id)
    trackActivity({
      session_id,
      logged_in: true,
      user_id: user.id,
      person_name: user.full_name,
      login_time: new Date().toISOString(),
    })
    Cookies.set("token", data.access_token, { expires: 30, path: "/" }) // 30 days
    Cookies.set("tokenBC", data.bc_access_token, { expires: 30, path: "/" }) // 30 days
    return Promise.resolve(data)
  } catch (error) {
    console.log("Error ", error)
    let errorMsg =
      error && error.response && error.response.data
        ? error.response.data.message
        : "An error occurred, try again"
    dispatch(logoutAction())
    return Promise.reject(errorMsg)
  }
}

export const handleSocketConnection = (pushEvent, userId) => async (dispatch) => {
  dispatch({
    type: "WEBSOCKET_ACTION",
    pushEvent,
    receiveEvent: "response",
    emit: true,
    metadata: {},
    payload: {
      userId,
      applicationName: `vsla_${process.env.REACT_APP_PWA_APP_ENV}`,
    },
  })
}
export const trackActivity = (data) => async (dispatch) => {
  const position = await getGeolocation().catch(() => Promise.resolve())
  let geoLocation = null
  if (position) {
    let latitude = position.coords.latitude
    let longitude = position.coords.longitude
    geoLocation = {
      longitude,
      latitude,
    }
  }
  dispatch(
    handleSocketConnection(`${data.logged_in ? "" : "dis"}connected`, data.user_id),
  )

  const config = {
    type: "WEBSOCKET_ACTION",
    pushEvent: "action-log",
    receiveEvent: "response",
    emit: true,
    protocol: "ws",
    payload: {
      data: {
        login_time: null,
        logout_time: null,
        ...data,
        geoLocation,
        uuid: uuid(),
        app: "vsla",
        env: window.REACT_APP_PWA_APP_ENV,
      },
    },
  }
  safeApiCall(config)
}
